export interface IQuerySearch{
  [x : string]: unknown ;
}
